import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { formatImageUrl } from '../../shared/utils/formatImageUrl';
import { dateToString } from '../../shared/utils/parseDate.js';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const PortfolioPage = () => {
  const [portfolio, setPortfolios] = useState([]);
  const [categories, setCategories] = useState([]);
  const [industries, setIndustries] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [filterValues, setFilterValues] = useState({ categoryId: null, industryId: null });
  const [searchParams, setSearchParams] = useSearchParams();

  const getFilters = () => {
    apiRequests.portfolio.getCategories(100, 0).then((res) => setCategories(res));
    apiRequests.portfolio.getIndustries(100, 0).then((res) => setIndustries(res));
  };

  const getData = (count = 10, offset = 0) => {
    apiRequests.portfolio.get(count, offset).then((res) => setPortfolios(res));
  };

  useEffect(() => {
    const categoryId = searchParams.get('categoryId');
    const industryId = searchParams.get('industryId');
    
    if (categoryId || industryId) {
      apiRequests.portfolio.getFiltered('', categoryId, industryId).then((res) => setPortfolios(res));
    } else {
      getData();
    }
    
    setFilterValues({
      categoryId: categoryId || null,
      industryId: industryId || null,
    });
    getFilters();
  }, []);

  const handleDelete = (id) => {
    apiRequests.portfolio.delete(id).then(() =>
      setPortfolios((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
  };

  const handleSearch = () => {
    if (searchValue === '') {
      getData();
    } else {
      apiRequests.portfolio.getFiltered(searchValue, filterValues.categoryId, filterValues.industryId).then((res) => setPortfolios(res));
    }
  };

  const handleFilterChange = (key, value) => {
    setFilterValues((prev) => ({ ...prev, [key]: value }));
  };

  const applyFilters = () => {
    setSearchParams((prev) => {
      Object.entries(filterValues).forEach(([key, value]) => {
        if (value) prev.set(key, value);
        else prev.delete(key);
      });
      return prev;
    });
    
    if (filterValues.categoryId || filterValues.industryId) {
      apiRequests.portfolio.getFiltered(searchValue, filterValues.categoryId, filterValues.industryId).then((res) => setPortfolios(res));
    } else {
      getData();
    }
  };

  const resetFilters = () => {
    setFilterValues({ categoryId: null, industryId: null });
    setSearchParams({});
    getData();
  };

  const filters = [
    {
      key: 'categoryId',
      type: 'select',
      label: 'Категория',
      value: filterValues.categoryId,
      placeholder: 'Все категории',
      options: categories?.items?.map((c) => ({ value: c.id, label: c.title })) || [],
    },
    {
      key: 'industryId',
      type: 'select',
      label: 'Индустрия',
      value: filterValues.industryId,
      placeholder: 'Все индустрии',
      options: industries?.items?.map((i) => ({ value: i.id, label: i.title })) || [],
    },
  ];

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск портфолио..."
        filters={filters}
        onFilterChange={handleFilterChange}
        onApplyFilters={applyFilters}
        onResetFilters={resetFilters}
        createLink="/portfolio/create"
      />

      <div className="mb-3">
        {portfolio.items?.length === 0 ? (
          <p className="text-center">По вашему запросу ничего не найдено</p>
        ) : (
          portfolio.items?.map((item) => (
            <EntityCard
              key={item.id}
              image={formatImageUrl(item.imgPath)}
              title={item.title}
              fields={[
                { label: 'Категория', value: item.category?.title },
                { label: 'Создано', value: dateToString(item.createdAt) },
              ]}
              editLink={`/portfolio/${item.id}`}
              localizationLink={`/portfolio/${item.id}/localization`}
              onDelete={() => handleDelete(item.id)}
            />
          ))
        )}
      </div>

      <Pagination
        count={portfolio.totalCount}
        itemsPerPage={10}
        onChange={(page) => getData(10, page * 10)}
      />
    </>
  );
};

export default PortfolioPage;
